import React, { useState, useEffect } from "react";
import Footer from "./common/Footer";
import Navbar from "./common/Navbar";
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import {FormGroup, FormControlLabel, Checkbox, Alert, Typography} from '@mui/material';
import PaidIcon from '@mui/icons-material/Paid';
import CreateIcon from '@mui/icons-material/Create';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';
import bannerOne from '../images/44.jpg';
import bannerTwo from '../images/22.jpg';
import bannerThree from '../images/11.jpg';
import instance from "../config/axios";

const divStyle = {
  display: 'flex',
  flexDirection: "column",
  alignItems: 'start',
  justifyContent: 'center',
  backgroundSize: 'cover',
  height: '400px',
  padding: "40px"
}
const slideImages = [
  {
    url: bannerOne,
    h3: 'Welcome to Your Financial Freedom',
	p: "Discover tailored loan solutions for every need"
  },
  {
    url: bannerTwo,
    h3: 'Personal Loans Made Easy',
	p: 'Fast approvals and competitive rates to help you achieve your goals.'
  },
  {
    url: bannerThree,
        h3: 'Fuel Your Business Growth',
		p: 'Flexible funding options to take your business to the next level.'
  },
];

const Home = () => {
	const [title, setTitle] = useState("");
	const [firstName, setFirstName] = useState("");
	const [lastName, setLastName] = useState("");
	const [email, setEmail] = useState("");
	const [phoneNo, setPhoneNo] = useState("");
	const [bankName, setBankName] = useState("");
	const [accountNo, setAccountNo] = useState("");
	const [gender, setGender] = useState("");
	const [dob, setDOB] = useState("");
	const [BVN, setBVN] = useState("");
	const [address, setAddress] = useState("");
	const [placeOfWork, setPlaceOfWork] = useState("");
	const [employmentDate, setEmploymentDate] = useState("");
	const [applicantLocation, setApplicationLocation] = useState("");
	const [ippis, setIPPIS] = useState("");
	const [lastSalary, setLastSalary] = useState("");
	const [loanAmount, setLoanAmount] = useState("");
	const [repaymentNo, setRepaymentNo] = useState(1);
	const [referralCode, setReferralCode] = useState("");
	const [statusNews, setStatusNew ] = useState(null);
	const [bankList, setBankList] = useState([]);
	const [buttonState, setButtonState] = useState(false);
	const [apiMessage, setApiMessage] = useState("");
	const [interestRate, setInterestRate] = useState([]);
	const [repaymentAmount, setRepaymentAmount] = useState(0);
	const [message, setMessage] = useState("");
	const statesInNigeria = [
		"Abia",
		"Adamawa",
		"Akwa Ibom",
		"Anambra",
		"Bauchi",
		"Bayelsa",
		"Benue",
		"Borno",
		"Cross River",
		"Delta",
		"Ebonyi",
		"Edo",
		"Ekiti",
		"Enugu",
		"Gombe",
		"Imo",
		"Jigawa",
		"Kaduna",
		"Kano",
		"Katsina",
		"Kebbi",
		"Kogi",
		"Kwara",
		"Lagos",
		"Nasarawa",
		"Niger",
		"Ogun",
		"Ondo",
		"Osun",
		"Oyo",
		"Plateau",
		"Rivers",
		"Sokoto",
		"Taraba",
		"Yobe",
		"Zamfara",
		"Federal Capital Territory (FCT)"
	  ];
	

	useEffect(() => {
		instance({
			method: "GET",
			headers: {
				'Content-Type': 'application/json',
			  },
			url: "/WebEntry/BankList"
		}).then(response => {
			setBankList(response.data.data)
		}).catch(err => setStatusNew("bankError"));

		instance({
			method: "GET",
			headers: {
				'Content-Type': 'application/json',
			  },
			url: `/WebEntry/FetchLoanRateList`
		}).then(response => {
			setInterestRate(response.data.data);
		}).catch(err => setStatusNew("bankError"));
	},[])

	useEffect(() => {

		/**Extracting rate info from endpoint data  */
		function findByRepayment(value) {
			return interestRate.reduce((acc, item) => {
				if (item["Min"] === value || item["Max"] === value) {
					acc = item;
				}
				return acc;
			}, null);
		}
		if(parseInt(repaymentNo) > 0 && parseFloat(loanAmount) > 0){
			const principal = parseFloat(loanAmount);
			const tenure = parseFloat(repaymentNo);
			const rateInfo = findByRepayment(parseInt(repaymentNo));

			if(!rateInfo){
				setMessage("We currently don't offer facility for this duration.");
				setStatusNew("repaymentError");
				setRepaymentAmount(formatNumber(0));
			}else{
				const total = formatNumber((principal / tenure) + (principal * parseFloat(rateInfo?.RateFraction)) + (6000 / parseFloat(tenure)));
				setRepaymentAmount(total);
				setStatusNew("repaymentSuccess");
			}

		}else{
			setRepaymentAmount(formatNumber(0));
		}
	}, [loanAmount, repaymentNo, interestRate]);


	const submitApplication = e => {
		e.preventDefault();
		setButtonState(true);
		instance({
			method: "POST",
			headers: {
				'Content-Type': 'application/json',
			  },
			data: {Title: title, FirstName: firstName, LastName: lastName, Gender: gender, Email: email, DateOfBirth: dob, SalAccountNumber: accountNo, SalBankName: bankName, BVN: BVN, HouseAddress: address, OfficeName: placeOfWork, DateOfEmployment: employmentDate, State: applicantLocation, PhoneNumber: phoneNo, IPPISNumber: ippis, LoanAmount: loanAmount, RepaymentNo: repaymentNo, ReferralCode: referralCode, LastSalaryAmt:  lastSalary},
			url: "/WebEntry"
		}).then(response => {
			if(response.data.responseCode === "200"){
				setStatusNew("success");
			}else{
				setStatusNew("error");
				setApiMessage(response.data.responseDescription);
			}
			setButtonState(false);
			setTitle("");
			setFirstName("");
			setLastName("");
			setEmail("");
			setPhoneNo("");
			setBankName("");
			setAccountNo("");
			setGender("");
			setDOB("");
			setBVN("");
			setAddress("");
			setPlaceOfWork("");
			setEmploymentDate("");
			setApplicationLocation("");
			setIPPIS("");
			setLastSalary("");
			setLoanAmount("");
			setRepaymentNo("");
			setReferralCode("");
			setTimeout(() => {
				setStatusNew(null);
			}, 10000);
		}).catch(err => {
			setStatusNew("error");
			setApiMessage(err?.response?.data?.responseDescription);
			setButtonState(false);
			setTitle("");
			setFirstName("");
			setLastName("");
			setEmail("");
			setPhoneNo("");
			setBankName("");
			setAccountNo("");
			setGender("");
			setDOB("");
			setBVN("");
			setAddress("");
			setPlaceOfWork("");
			setEmploymentDate("");
			setApplicationLocation("");
			setIPPIS("");
			setLastSalary("");
			setLoanAmount("");
			setRepaymentNo("");
			setReferralCode("");
			setTimeout(() => {
				setStatusNew(null);
			}, 10000)
		})
	}

	const formatNumber = (input, locale = 'en-US', options = {minimumFractionDigits: 2}) => {
		const number = typeof input === 'string'
			? parseFloat(input.replace(/,/g, ''))
			: input;
		if (isNaN(number)) {
		//  setMessage('Value is not a valid number.');
			return;
		}
		return new Intl.NumberFormat(locale, options).format(number);
	}

	return (
		<>
		<Navbar />
			<section className="sec_1">
				<div className="header_height d-flex align-items-center">
					<div className="slider_container"><Slide>
						 {slideImages.map((slideImage, index)=> (
							<div key={index}>
							  <div style={{ ...divStyle, 'backgroundImage': `url(${slideImage.url})` }}>
							  <h2 className="hdrcolor">{slideImage.h3}</h2>
							  <small className="text-black">{slideImage.p}</small>
							  </div>
							</div>
						  ))} 
						</Slide>
					</div>
				</div>
			</section>

			<section>
				<div className="container mx-auto py-5">
					<div className="mb-4 text-center">
						<p className="display-6 mb-1">How we do it</p>
						<p className="text-muted"></p>
					</div>
					<div className="row gy-5 d-flex align-items-stretch align-items-center justify-content-evenly mt-0">
						<div className="col-md-4 col-lg-3 text-center">
							<div className="box_border position-relative align-items-center text-align justify-content-evenly rounded h-100 pt-5 pb-3 px-3">
								<div className="shp"><ConfirmationNumberIcon sx={{ fontSize: 30 }} /></div>
								<h3 className="mb-2 mt-4">Check Repayment</h3>
								<p className="text-muted text-left text-xl-center text-lg-center">Enter the loan amount and see repayment based on the duration</p>
							</div>
						</div>
						<div className="col-md-4 col-lg-3 text-center">
							<div className="box_border position-relative align-items-center text-align justify-content-evenly rounded h-100 pt-5 pb-3 px-3">
								<div className="shp"><CreateIcon sx={{  fontSize: 30 }} /></div>
								<h3 className="mb-2 mt-4">Fill Out the Form</h3>
								<p className="text-muted text-left text-xl-center text-lg-center">Provide correct information in the forrm as it is needed to confirm your loan eligibilty.</p>
							</div>
						</div>
						<div className="col-md-4 col-lg-3 text-center">
							<div className="box_border position-relative align-items-center text-align justify-content-evenly rounded h-100 pt-5 pb-3 px-3">
								<div className="shp"><PaidIcon sx={{  fontSize: 30 }} /></div>
								<h3 className="mb-2 mt-4">Get the Loan</h3>
								<p className="text-muted text-left text-xl-center text-lg-center">Our team will check your eligibilty and process the loan if you are eligible. You get it within 24 hours.</p>
							</div>
						</div>
					</div>
				</div>
			</section>

			<section>
				<div className="container row py-5 m-auto">
					<div className="col-md-12 d-flex align-items-center justify-content-center order-1">
						<Box
							component="form"
							noValidate={false}
							autoComplete="off"
							className="col-lg-12 col-12 col-md-10 text-center"
							onSubmit={submitApplication}
						>
				
							<h5 className="display-6 text-center mb-2">Application Form</h5>
							<p>Please out the form correctly.</p>
							<div className="row">
								<div className="col-lg-6 col-md-6 mb-3">
									{statusNews === "success" ? <Alert variant="outlined" severity="success">
										Application was successfully submitted.
									</Alert> : statusNews === "error" ?
										<Alert variant="outlined" severity="error">
											The application could't be submitted, because {apiMessage}
										</Alert> : <></>}
								</div>
							</div>
							<div className="row">

								<div className="col-lg-4 col-md-6 mb-3">
									<TextField
									   required={true}
										id="title"
										select
										label="Please select your title"
										className="form-control"
										onChange={e => setTitle(e.target.value)}
										value={title}
									>
										<MenuItem value="Mr">
											Mr
										</MenuItem>
										<MenuItem value="Mrs">
											Mrs
										</MenuItem>
										<MenuItem value="Miss">
											Miss
										</MenuItem>

									</TextField>
								</div>
								<div className="col-lg-4 col-md-6 mb-3">
									<TextField
										required={true}
										id="firstname"
										label="First Name"
										className="form-control"
										onChange={e => setFirstName(e.target.value)}
										value={firstName}
									/>
								</div>
								<div className="col-lg-4 col-md-6 mb-3">
									<TextField
										required={true}
										id="lastname"
										label="Last Name"
										className="form-control"
										onChange={e => setLastName(e.target.value)}
										value={lastName}
									/>
								</div>
								<div className="col-lg-4 col-md-6 mb-3">
									<TextField
									    required={true}
										id="title"
										select
										label="Please select your gender"
										className="form-control"
										onChange={e => setGender(e.target.value)}
										value={gender}
									>
										<MenuItem value="male">
											Male
										</MenuItem>
										<MenuItem value="female">
											Female
										</MenuItem>
									</TextField>
								</div>
								<div className="col-lg-4 col-md-6 mb-3">
									<TextField
										required={true}
										id="email"
										label="Email"
										className="form-control"
										type="email"
										value={email}
										onChange={e => setEmail(e.target.value)}
									/>
								</div>
								<div className="col-lg-4 col-md-6 mb-3">
									<TextField
										required={true}
										id="dob"
										label="Date of Birth"
										className="form-control"
										type="date"
										onChange={e => setDOB(e.target.value)}
										value={dob}
										InputLabelProps={{
											shrink: true, 
										  }}
									/>
								</div>
								<div className="col-lg-4 col-md-6 mb-3">
									<TextField
										id="bankname"
										select
										label="Bank Name"
										className="form-control"
										required={true}
										onChange={e => setBankName(e.target.value)}
										value={bankName}
									>
									{
										bankList.map((bank, index) => {
											return 	<MenuItem key={index} value={bank.bankCode}>
											{bank.bankName}
										</MenuItem>
										})
									}

									</TextField>

								</div>
								<div className="col-lg-4 col-md-6 mb-3">
									<TextField
										required={true}
										id="phoneNo"
										label="Phone Number Linked to BVN"
										className="form-control"
										type="number"
										onChange={e => setPhoneNo(e.target.value)}
										value={phoneNo}
									/>
								</div>
								<div className="col-lg-4 col-md-6 mb-3">
									<TextField
										required={true}
										id="setAccountNo"
										label="Account Number"
										className="form-control"
										type="number"
										onChange={e => setAccountNo(e.target.value)}
										value={accountNo}
									/>
								</div>
								<div className="col-lg-4 col-md-6 mb-3">
									<TextField
										required={true}
										id="BVN"
										label="BVN"
										className="form-control"
										type="number"
										onChange={e => setBVN(e.target.value)}
										value={BVN}
									/>
								</div>
								<div className="col-lg-4 col-md-6 mb-3">
									<TextField
										required={true}
										id="address"
										label="Enter your Address"
										className="form-control"
										type="text"
										onChange={e => setAddress(e.target.value)}
										value={address}
									/>
								</div>
								<div className="col-lg-4 col-md-6 mb-3">
									<TextField
										required={true}
										id="placeOfWork"
										label="Enter your Place of Work"
										className="form-control"
										type="text"
										onChange={e => setPlaceOfWork(e.target.value)}
										value={placeOfWork}
			
									/>
								</div>
								<div className="col-lg-4 col-md-6 mb-3">
									<TextField
										required={true}
										id="dateofEmployment"
										label="Enter Date of Employment"
										className="form-control"
										type="date"
										onChange={e => setEmploymentDate(e.target.value)}
										InputLabelProps={{
											shrink: true, 
										  }}
										  value={employmentDate}
									/>
								</div>
								<div className="col-lg-4 col-md-6 mb-3">
									<TextField
										id="applicantState"
										select
										label="State Location"
										className="form-control"
										required={true}
										onChange={e => setApplicationLocation(e.target.value)}
										value={applicantLocation}
									>
									{
										statesInNigeria.map((states, index) => {
											return <MenuItem key={index} value={states}>
											{states}
										</MenuItem>
										})
									}
									</TextField>
								</div>
								<div className="col-lg-4 col-md-6 mb-3">
								<TextField
									required={true}
									id="ippisNumber"
									label="Employment Number"
									className="form-control"
									type="text"
									onChange={e => setIPPIS(e.target.value)}
									value={ippis}
								/>
								
							</div>
								<div className="col-lg-4 col-md-6 mb-3">
									<TextField
										required={true}
										id="lastSalary"
										label="Enter Last Salary"
										className="form-control"
										type="number"
										onChange={e => setLastSalary(e.target.value)}
										value={lastSalary}
									/>
								{	statusNews === "salaryError" &&
									<Alert variant="outlined" severity="error">
										{message}
									</Alert> }
								</div>
								<div className="col-lg-4 col-md-6 mb-3">
									<TextField
										required={true}
										id="loanAmount"
										label="Enter Loan Amount"
										className="form-control"
										type="number"
										onChange={e => setLoanAmount(e.target.value)}
										value={(loanAmount)}
									/>
									{"  "}
									{	statusNews === "LoanAmountError" &&
										<Alert variant="outlined" severity="error">
											{message}
										</Alert> }
								</div>
								<div className="col-lg-4 col-md-6 mb-3">
								<TextField
								required={true}
								id="loanAmount"
								label="Enter Loan Tenure"
								className="form-control"
								type="number"
								value={repaymentNo} 
								onChange={(e) => setRepaymentNo(e.target.value)}
							  />
							  {	statusNews === "repaymentError" &&
								<Alert variant="outlined" severity="error">
									{message}
								</Alert> }
								</div>
								<div className="col-lg-4 col-md-6 mb-3">
									<TextField
										id="referralCode"
										label="Enter Referral Code"
										className="form-control"
										type="text"
										onChange={e => setReferralCode(e.target.value)}
										value={referralCode}
									/>
								</div>
								<div className="col-lg-4 col-md-6 mb-3" style={{display: "flex", alignItems: "center", justifyContent: "center", padding: 0}}>
									<Typography variant="h6">
											  Repayment Amount:

											</Typography>
											<Typography variant="p" sx={{fontWeight: 600, fontSize: 15 + "px", marginLeft: 10 + "px", marginBottom: 0}}>
											{repaymentAmount}
											</Typography>
							</div>
							</div>
							<FormGroup>
								<FormControlLabel required={true} sx={{textAlign: "justify", fontSize: "0.9rem"}} control={<Checkbox />} label="By clicking “APPLY NOW”, I consent to Beryls Financials (owned by Beryls Management Limited) obtaining information from relevant third parties as may be necessary, on my employment details, salary payment, loans, and other related data, to decide on my loan application. Additionally, you confirm your acknowledgement and acceptance of our *Privacy Policy and Loan Terms and Conditions*. You also consent to the repayment amount being deducted from your salary at source, before credit to your account and any outstanding payments being recovered automatically from any other accounts linked to you in the case of default." />
							</FormGroup>
							<div className="row">
								<div className="col-lg-6 col-md-6 mb-3">
									{statusNews === "success" ? 
									<Alert variant="outlined" severity="success">
										Application was successfully submitted.
									</Alert> : statusNews === "error" ?
										<Alert variant="outlined" severity="error">
											The application could't be submitted, because {apiMessage}
									    </Alert> : <></>
									}
								</div>
							</div>
							<button className="btn btn-lg btn_custom btn_shadow w-25" disabled={buttonState}>{buttonState ? "Processing" : "Submit"}
							</button>
						</Box>
					</div>
				</div>
			</section>

			<Footer />
		</>
	);
};

export default Home;